var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfessional = function SvgProfessional(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M42.148 36.726H2V9.24A2.5 2.5 0 0 1 4.499 6.74h35.15a2.5 2.5 0 0 1 2.499 2.5zM14.577 6.74V4.243a2.5 2.5 0 0 1 2.499-2.499h9.995a2.5 2.5 0 0 1 2.499 2.499V6.74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M42.147 16.736a5 5 0 0 1-4.997 4.997H27.07M17.076 21.733H6.998A5 5 0 0 1 2 16.736"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M24.573 24.232h-4.998a2.5 2.5 0 0 1-2.499-2.498v-2.5h9.995v2.5a2.5 2.5 0 0 1-2.498 2.498"
  })));
};
export default SvgProfessional;